<div>
  <app-burger-menu></app-burger-menu>
<!--  <nav routerLink="/events">-->
<!--    <a class="nav-item" routerLink="/events">Мероприятия</a>-->
<!--  </nav>-->
<!--  <nav routerLink="/logs" *ngIf="isSuperuser()">-->
<!--    <a class="nav-item" routerLink="/logs">Логи</a>-->
<!--  </nav>-->
<!--  <nav class="right-item">-->
    <!--    <a class="nav-item btn" routerLink="/settings"><i id="btn-settings" class="fa fa-cog"></i></a>-->
    <!--    <a class="nav-item btn" routerLink="/auth"><i id="btn-punches" class="fa fa-user"></i></a>-->
<!--  </nav>-->
  <div style="height: 100%;">
    <router-outlet></router-outlet>
  </div>
</div>
